export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Filters.vue?vue&type=template&id=015b468c&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/Quotations/Filters.vue?vue&type=template&id=015b468c&scoped=true
// module id = 2318
// module chunks = 31